<template>
  <div>
    <div :class="{'c-sidebar__active-group': group === 'panels'}">
      <router-link
        class="c-sidebar__item c-sidebar__item-main"
        exact :to="{ name: 'cis.session'}">
        {{$t('panels')}}
      </router-link>
    </div>

    <div :class="{'c-sidebar__active-group': $route.fullPath.includes('results')}">
      <router-link
        class="c-sidebar__item c-sidebar__item-main c-sidebar__item-with-children c-sidebar__item-open"
        :class="{'c-sidebar__item-open': $route.fullPath.includes('results')}"
        exact :to="{ name: 'cis.session.results'}">
        {{ $t('results') }}
      </router-link>

      <template v-if="$route.fullPath.includes('results')">
        <router-link v-for="sessionCategory in session.categories" :key="sessionCategory.categoryId"
                     class="c-sidebar__item"
                     :to="{ name: 'cis.category', params: {categoryId: sessionCategory.categoryId}}">
          {{ categoryLabel(sessionCategory) }}
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import filter from 'lodash/filter'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'

export default {
  name: 'cis-menu',
  data: function () {
    return {
      group: 'panels',
    }
  },
  computed: {
    discipline: function () {
      return this.$store.state.eventDiscipline.discipline
    },
    session: function () {
      return find(this.$store.state.sessions.items, i => i.id === this.$route.params.sessionId)
    },
    categories: function () {
      return sortBy(this.$store.state.categories.items, 'index')
    },
    panels: function () {
      return sortBy(filter(this.$store.state.panels.items, i => i.sessionId === this.session.id), ['set', 'index'])
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: function(to) {
        const name = to.name
        if (name === 'cis.session' || name === 'cis.session.panels') {
          this.group = 'panels'
        } else {
          this.group = 'results'
        }
      },
    },
  },
  methods: {
    categoryLabel: function (sessionCategory) {
      const category = find(this.categories, i => i.id === sessionCategory.categoryId)
      return category.name
    },
  },
};
</script>
